import { Home } from "../home";

export const CustomRegistrationPage = () => {
  return <Home preliminaryMode={true} />;
};
